"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const idp_1 = require("./services/auth/idp");
const auth_manager_1 = require("./services/auth/auth-manager");
const configuration_1 = require("@common/configuration");
const token_validator_1 = require("./services/auth/token-validator");
const { v4: uuid_v4 } = require("uuid");
const jwtDecode = require("jwt-decode");
const IFRAME_AUTH_INTERVAL = 1000 * 540; //540sec -> 9min
class ConnectToAcquisitions extends React.Component {
    constructor(props) {
        super(props);
        this.checkAndSaveAccessFromAcquisitions();
        this.showIframe = this.showIframe.bind(this);
        const isAuthIframe = this.isAuthIframe();
        if (isAuthIframe) {
            this.state = {
                ready: true,
                isAuthIframe: isAuthIframe,
                frameReady: false,
                error: null,
            };
        }
        else {
            this.sessionCheckAndRedirect();
            this.state = {
                ready: false,
                isAuthIframe: isAuthIframe,
                frameReady: false,
                idpRefreshUrl: idp_1.getIdpRefreshUrl(),
                iframeKey: uuid_v4(),
                error: null,
            };
        }
    }
    isAuthIframe() {
        const jwt = auth_manager_1.authManager.getJwt();
        try {
            return auth_manager_1.authManager.checkJwt(jwt);
        }
        catch (error) {
            console.error(error);
            return false;
        }
    }
    componentDidMount() {
        if (this.state.isAuthIframe) {
            this.checkForRefreshToken();
        }
        else {
            if (idp_1.isTokenInHash()) {
                this.displayApp(idp_1.getTokenFromHash());
            }
            if (idp_1.isIdpError()) {
                this.displayApp("");
            }
        }
        setInterval(this.showIframe, IFRAME_AUTH_INTERVAL);
    }
    checkAndSaveAccessFromAcquisitions() {
        if (this.props.tokenFromAcq) {
            // validate the token before saving it
            const validation = token_validator_1.TokenValidator.validateToken(this.props.tokenFromAcq, {
                expectedAudience: configuration_1.Configuration.acqBackendConfig().audience,
            });
            if (validation.isValid) {
                const tokenInfo = token_validator_1.TokenValidator.getTokenInfo(this.props.tokenFromAcq);
                auth_manager_1.authManager.removeTokenFromAcq();
                auth_manager_1.authManager.saveToken(this.props.tokenFromAcq, auth_manager_1.authManager.tokenFromAcq);
                auth_manager_1.authManager.saveToken(this.props.tokenFromAcq, auth_manager_1.authManager.jwt);
                return true;
            }
            else {
                console.error('Token validation failed:', validation.errors);
                return false;
            }
        }
        return false;
    }
    displayApp(token, iframeUrl) {
        if (!token && !idp_1.isSearchForward() && !idp_1.isIdpError() && idp_1.isValidUrlForRedirect(iframeUrl)) {
            const lastSession = auth_manager_1.authManager.getLastSession();
            return idp_1.redirectToIdp(`display app no token - url: ${iframeUrl} - last good session: ${lastSession} - requested url: ${this.state.idpRefreshUrl}`);
        }
        try {
            idp_1.validateResponseFromIdp();
            if (token) {
                this.setToken(token);
            }
            this.setState({ ready: true, frameReady: false });
        }
        catch (error) {
            console.error(error);
            this.setState({ ready: false, frameReady: false, error: error });
        }
    }
    showIframe() {
        this.setState({
            idpRefreshUrl: idp_1.getIdpRefreshUrl(),
            frameReady: true,
            iframeKey: uuid_v4(),
        });
    }
    checkForRefreshToken() {
        const token = idp_1.isTokenInHash() ? idp_1.getTokenFromHash() : null;
        token ? this.refreshToken(token) : this.displayApp("", window.location.href);
    }
    refreshToken(token) {
        this.setToken(token);
        this.setState({ frameReady: false });
    }
    setToken(token) {
        // Validate the token before saving it
        const validation = token_validator_1.TokenValidator.validateToken(token, {
            expectedAudience: configuration_1.Configuration.acqBackendConfig().audience,
        });
        if (validation.isValid) {
            auth_manager_1.authManager.saveToken(token, auth_manager_1.authManager.jwt);
            const decodedToken = jwtDecode(token);
            const newUser = decodedToken.sub ? decodedToken.sub : JSON.stringify(decodedToken);
            const user = auth_manager_1.authManager.getLastSession();
            if (user && user !== newUser) {
                this.logOutAndReload();
                return;
            }
            auth_manager_1.authManager.saveToken(newUser, auth_manager_1.authManager.lastSession);
        }
        else {
            console.error('Token validation failed during refresh:', validation.errors);
            this.logOutAndReload();
        }
    }
    sessionCheckAndRedirect() {
        if (!idp_1.isTokenInHash() && auth_manager_1.authManager.checkJwt(auth_manager_1.authManager.getJwt()) === false) {
            const lastSession = auth_manager_1.authManager.getLastSession();
            idp_1.redirectToIdp(`no op session - last good session: ${lastSession}`);
        }
    }
    logOutAndReload() {
        auth_manager_1.authManager.removeToken();
        this.setState({
            ready: false,
            error: "NA",
        });
    }
    render() {
        const isAppReady = this.state.ready;
        const displayAuthIframe = this.state.frameReady;
        const error = this.state.error;
        return (React.createElement(React.Fragment, null,
            isAppReady ? (this.props.children) : error ? (React.createElement("div", null,
                React.createElement("h3", null, "Problems with your session, please reload the page."),
                React.createElement("p", null, error.message))) : (React.createElement("div", { style: { textAlign: "center", position: "absolute", top: "50%", left: "50%" } },
                React.createElement("h6", null, "Connecting to services..."))),
            displayAuthIframe && (React.createElement("iframe", { key: this.state.iframeKey, title: this.state.iframeKey, src: this.state.idpRefreshUrl, style: { display: "none" } }))));
    }
}
exports.ConnectToAcquisitions = ConnectToAcquisitions;
//# sourceMappingURL=ConnectToAcquisitions.js.map